import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Commons from '../../../../Services/Common/Common';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import useDelete from '../../../../hooks/useDeleteN';
import { useSave } from '../../../../hooks/useSaveN';
import useActionLog from '../../../../hooks/useActionLog';
import { IND_BASIC } from './index';
import {
  useDelete1,
  useSave1,
  useSearch1,
  useSearch2,
  useSearch3,
} from './IND_BASIC_QUERY';
import { IND_BASIC_Schema } from './IND_BASIC_Schema';

const SCREEN_MENU_ID = 'IndustryMenu';

function IND_BASICF() {
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const { SaveActionLog } = useActionLog();

  const gridRef1 = useRef();
  const gridRef2 = useRef();
  const gridRef3 = useRef();
  const currentRowIndexRef1 = useRef(null);

  const [rowData1, setRowData1] = useState([]);
  const [selectedRowData1, setSelectedRowData1] = useState([]);
  const [rowData2, setRowData2] = useState([]);
  const [selectedRowData2, setSelectedRowData2] = useState([]);
  const [, setChangedRowData2] = useState([]);
  const [deletedRowData2, setDeletedRowData2] = useState([]);
  const selectedRowNosRef2 = useRef(new Set());
  const lastCheckedIndexRef2 = useRef(null);
  const currentRowIndexRef2 = useRef(null);

  const [modalToggle1, setModalToggle1] = useState(false);
  const [modalRowData1, setModalRowData1] = useState([]);
  const [selectedModalRowData1, setSelectedModalRowData1] = useState([]);
  const selectedRowNosRef3 = useRef(new Set());
  const lastCheckedIndexRef3 = useRef(null);
  const currentRowIndexRef3 = useRef(null);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [pendingRows, setPendingRows] = useState([]);

  const { refetch: RefetchIndR1 } = useSearch1({
    onErrorRow: (errRow) => {
      dispatch(
        showSnackbar({
          message: errRow?.message ?? '조회 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
    },
    onSuccess: (rows) => {
      const list = rows || [];
      if (!list.length) {
        setRowData1([]);
        return;
      }
      setRowData1(Commons.InsertNumber(list));
    },
  });

  const { runAsync: SearchProgramList } = useSearch2({
    onSuccess: (rows) => {
      const list = rows || [];
      if (!list.length) {
        setRowData2([]);
        return;
      }
      setRowData2(Commons.InsertNumber(list));
    },
  });

  const { runAsync: SearchModalList } = useSearch3({
    onSuccess: (rows) => {
      const list = rows || [];
      if (!list.length) {
        setModalRowData1([]);
        return;
      }
      setModalRowData1(Commons.InsertNumber(list));
    },
  });

  const saveLinkMutation = useSave1({ userInfo });
  const deleteMutation = useDelete1();

  const deleteHandler2 = useDelete({
    gridRef: gridRef2,
    deleteMutation,
    updateDeleted: setDeletedRowData2,
    updateRowData: setRowData2,
    deletedRowData: deletedRowData2,
    rowData: rowData2,
    setChangedRowData: setChangedRowData2,
  });

  const SearchLogic1 = async () => {
    setRowData2([]);
    setSelectedRowData1([]);
    setSelectedRowData2([]);
    setChangedRowData2([]);
    setDeletedRowData2([]);
    currentRowIndexRef1.current = null;
    gridRef1?.current?.api?.deselectAll();
    gridRef2?.current?.api?.deselectAll();
    await RefetchIndR1();
  };

  const SearchLogic2 = async (plType) => {
    if (!plType) {
      setRowData2([]);
      return;
    }
    setSelectedRowData2([]);
    setChangedRowData2([]);
    setDeletedRowData2([]);
    gridRef2?.current?.api?.deselectAll();
    await SearchProgramList({ plType });
  };

  const SearchLogic3 = async (plType) => {
    if (!plType) {
      setModalRowData1([]);
      return;
    }
    setModalRowData1([]);
    setSelectedModalRowData1([]);
    selectedRowNosRef3.current = new Set();
    gridRef3?.current?.api?.deselectAll?.();
    await SearchModalList({ plType });
  };

  useEffect(() => {
    SearchLogic1();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- 최초 마운트 시 구분 목록만 조회
  }, []);

  const saveIndustryDelete = useSave({
    menuId: SCREEN_MENU_ID,
    schema: { fields: IND_BASIC_Schema.fieldsProgramLink },
    getChangedRows: () => [],
    getDeletedRows: () => deletedRowData2,
    requestDelete: deleteHandler2.DeleteLogic,
    requestSave: async () => [],
    onSuccessRefresh: async ({ deleteDetailData }) => {
      const delFail = (deleteDetailData ?? []).some(
        (r) => r?.isSuccess === false
      );
      if (delFail) return;
      setChangedRowData2([]);
      setDeletedRowData2([]);
      setSelectedRowData2([]);
      gridRef2?.current?.api?.deselectAll?.();
      const plType = selectedRowData1?.[0]?.PL_TYPE;
      if (plType) {
        await SearchProgramList({ plType });
      }
    },
  });

  const SaveLogic1 = async () => {
    if (!(deletedRowData2?.length > 0)) {
      dispatch(
        showSnackbar({
          message: '삭제할 행을 선택해 주세요.',
          type: 'warning',
        })
      );
      return;
    }
    await saveIndustryDelete.run();
  };

  const SaveLogic2 = async (plType, pending) => {
    const rows = (pending || [])
      .map((item) => ({
        ...item,
        PL_TYPE: plType,
      }))
      .filter((r) => String(r.PRO_ID ?? '').trim() !== '');

    if (!rows.length) {
      dispatch(
        showSnackbar({
          message: '저장할 데이터가 없습니다.',
          type: 'warning',
        })
      );
      return;
    }

    try {
      const result = await saveLinkMutation.runAsync(rows);

      if (!result || result.length === 0) {
        dispatch(
          showSnackbar({
            message: '저장 후 반환된 값이 없습니다.',
            type: 'error',
          })
        );
        return;
      }

      const fail = result.some((r) => r.isSuccess === false);
      if (fail) {
        dispatch(
          showSnackbar({
            message:
              result.find((r) => r.isSuccess === false)?.message ||
              '저장 중 오류가 발생했습니다.',
            type: 'error',
          })
        );
        return;
      }

      await SaveActionLog(rows, {
        menuId: SCREEN_MENU_ID,
        coCd: userInfo.authCd === 'ADMIN' ? '' : userInfo.coCd,
        userId: userInfo.userid,
        logResult: 'SUCCESS',
      });

      dispatch(
        showSnackbar({
          message: '저장되었습니다.',
          type: 'success',
        })
      );

      setPendingRows([]);
      setConfirmOpen(false);
      setModalToggle1(false);
      await SearchProgramList({ plType });
      await SearchModalList({ plType });
    } catch (e) {
      await SaveActionLog(rows, {
        menuId: SCREEN_MENU_ID,
        coCd: userInfo.authCd === 'ADMIN' ? '' : userInfo.coCd,
        userId: userInfo.userid,
        logResult: 'ERROR',
        errorMsg: e.message,
      });

      dispatch(
        showSnackbar({
          message: e.message,
          type: 'error',
        })
      );
    }
  };

  const handleSaveFromModal = (selectedFromEvent = null) => {
    const selectedRows = selectedFromEvent
      ? [selectedFromEvent]
      : selectedModalRowData1;

    if (!selectedRows || selectedRows.length === 0) {
      dispatch(
        showSnackbar({ message: '선택된 행이 없습니다.', type: 'warning' })
      );
      return;
    }

    setPendingRows(selectedRows);
    setConfirmOpen(true);
  };

  const handleRowSelection1 = (rowData, rowIndex) => {
    currentRowIndexRef1.current = rowIndex;
    setSelectedRowData1([rowData]);
  };

  const handleRowSelection2 = (rowData, rowIndex) => {
    currentRowIndexRef2.current = rowIndex;
    setSelectedRowData2([rowData]);
  };

  const handleRowSelection3 = (rowData, rowIndex) => {
    currentRowIndexRef3.current = rowIndex;
    setSelectedModalRowData1([rowData]);
  };

  const NewYnErrorMsg = () => {
    dispatch(
      showSnackbar({
        message: '데이터 입력중입니다. 저장 후 시도하세요.',
        type: 'warning',
      })
    );
  };

  return (
    <div className="wrap">
      <IND_BASIC
        dispatch={dispatch}
        showSnackbar={showSnackbar}
        userInfo={userInfo}
        gridRef1={gridRef1}
        gridRef2={gridRef2}
        gridRef3={gridRef3}
        rowData1={rowData1}
        setRowData1={setRowData1}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        currentRowIndexRef1={currentRowIndexRef1}
        rowData2={rowData2}
        selectedRowData2={selectedRowData2}
        setSelectedRowData2={setSelectedRowData2}
        setChangedRowData2={setChangedRowData2}
        selectedRowNosRef2={selectedRowNosRef2}
        lastCheckedIndexRef2={lastCheckedIndexRef2}
        modalToggle1={modalToggle1}
        setModalToggle1={setModalToggle1}
        modalRowData1={modalRowData1}
        selectedModalRowData1={selectedModalRowData1}
        setSelectedModalRowData1={setSelectedModalRowData1}
        selectedRowNosRef3={selectedRowNosRef3}
        lastCheckedIndexRef3={lastCheckedIndexRef3}
        confirmOpen={confirmOpen}
        setConfirmOpen={setConfirmOpen}
        pendingRows={pendingRows}
        setPendingRows={setPendingRows}
        SearchLogic1={SearchLogic1}
        SearchLogic2={SearchLogic2}
        SearchLogic3={SearchLogic3}
        SaveLogic1={SaveLogic1}
        SaveLogic2={SaveLogic2}
        MarkedForDeletion2={deleteHandler2.MarkedForDeletion}
        RestoreRow2={deleteHandler2.RestoreRow}
        DeleteNewRow2={deleteHandler2.DeleteNewRow}
        handleRowSelection1={handleRowSelection1}
        handleRowSelection2={handleRowSelection2}
        handleRowSelection3={handleRowSelection3}
        NewYnErrorMsg={NewYnErrorMsg}
        handleSaveFromModal={handleSaveFromModal}
      />
    </div>
  );
}

export default IND_BASICF;
